import { usePost } from '../../HttpClient';
import { referenceDataBaseUrl } from '../BaseUrls';
import { useMutationWithErrorHandling } from '../../../hooks/UseMutationWithErrorHandling';

export function useCreateAccountFlagDefinition() {
  const post = usePost(true, "tms");
  const createAccountFlagDefinition = (request: any) =>
    post<{ id: string }>(`${referenceDataBaseUrl}/account-flag-definitions`, request);

  return useMutationWithErrorHandling({
    mutationFn: async (request: any) => await createAccountFlagDefinition(request),
  });
}
